/* eslint-disable no-nested-ternary */

import { Icon, Loading } from "@bluframe/blublocks"
import colors from "styles/colors"

import { Props } from "."
import { LoadingWrapper, Paragraph, Wrapper } from "./styled"

const Check = ({ disabled, isGreen, isLoading, label }: Props) => (
  <Wrapper>
    {isLoading ? (
      <LoadingWrapper>
        <Loading size={18} />
      </LoadingWrapper>
    ) : isGreen ? (
      <Icon color={colors.apple} group="fa6" name="FaCircleCheck" size="18" />
    ) : disabled ? (
      <Icon color={colors.nobel} group="fa6" name="FaCircleMinus" size="18" />
    ) : (
      <Icon color={colors.red} group="fa6" name="FaCircleXmark" size="18" />
    )}

    {label ? <Paragraph>{label}</Paragraph> : null}
  </Wrapper>
)

export default Check
